import { render, staticRenderFns } from "./pengguna.vue?vue&type=template&id=12525786&scoped=true&"
import script from "./pengguna.vue?vue&type=script&lang=js&"
export * from "./pengguna.vue?vue&type=script&lang=js&"
import style0 from "./pengguna.vue?vue&type=style&index=0&id=12525786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12525786",
  null
  
)

export default component.exports